import api from 'api'

type RemoveExclusionRequest = {
  ruleId: number
  placeGeoid: string
}

export const removeExclusion = async (
  request: RemoveExclusionRequest
): Promise<void> => {
  await api.delete(
    `/admin/wage/rules/${request.ruleId}/exclusions/${request.placeGeoid}`
  )
}
